<script>
import TextInput from "@/components/ui/inputs/TextInput.vue";
import SwitchInput from "@/components/ui/inputs/SwitchInput.vue";
import _ from "lodash";
import {mapGetters} from "vuex";
import {useOrderStore} from "../../../store/orderStore";
import {useDiscountStore} from "../../../store/discountStore";
import { usePlanStore } from "../../../store/planStore";

export default {
    name: "PurchaseRentDiscount",
    components: {SwitchInput, TextInput},
    setup() {
        const orderStore = useOrderStore();
        const discountStore = useDiscountStore();
        const planStore = usePlanStore();

        const handlePromoCodeInput = _.debounce(function (e) {
            if (e && e.target.value) {
                discountStore.fetchCouponDetails();
            } else {
                discountStore.setCoupon(null);
            }
        }, 500);

        const handleGiftCardCodeInput = _.debounce(function (e) {
            if (e && e.target.value) {
                discountStore.fetchGiftCardDetails();
            } else {
                discountStore.setGiftCard(null);
            }
        }, 500);

        return { orderStore, discountStore, handlePromoCodeInput, handleGiftCardCodeInput, planStore };
    },
    data() {
        return {
            couponCode: '',
            giftCardCode: '',
        }
    },
    computed: {
        ...mapGetters({
            // giftCardDiscountAmount: 'purchase/getGiftCardDiscount',
            // couponDiscountAmount: 'purchase/getCouponDiscountAmount',
            // orderData: 'purchase/getOrderData',
            // activeOrderDataIndex: 'purchase/getActiveOrderDataIndex',
        }),
        activeOrder() {
            // return this.orderData[this.activeOrderDataIndex];
        }
    },
    watch: {
        activeOrder(order) {
            if (order.coupon_code) {
                this.couponCode = order.coupon_code;
            }
            if (order.gift_card_code) {
                this.giftCardCode = order.gift_card_code;
            }
        }
    },
    created() {
        // this.couponCode = this.activeOrder.coupon_code;
        // this.giftCardCode = this.activeOrder.gift_card_code;
    },
    methods: {
    }
}
</script>

<template>
    <div class="purchase-rent-discount">
        <div class="purchase-rent-discount__title">
            <h1>{{ $t("purchase-rent-page.discount.title") }}</h1>
        </div>

        <div class="purchase-rent-discount__body">
            <div class="purchase-rent-discount__promo-code">
                <text-input
                    :label="$t('purchase-rent-page.discount.promoCode.label')"
                    :placeholder="$t('purchase-rent-page.discount.promoCode.placeholder')"
                    :disabled="planStore.plan_type === 'month'"
                    v-model="discountStore.couponCode"
                    @input="handlePromoCodeInput($event)"
                />

                <div
                    class="purchase-rent-discount__promo-code__info"
                >
                    <h5>{{ $t('purchase-rent-page.discount.promoCode.infoLabel') }}</h5>

                    <span>
                        ${{ discountStore.couponDiscountAmount }}
                    </span>
                </div>
            </div>
            <div class="purchase-rent-discount__gift-code">
                <text-input
                    :label="$t('purchase-rent-page.discount.giftCard.label')"
                    :placeholder="$t('purchase-rent-page.discount.giftCard.placeholder')"
                    v-model="discountStore.giftCardCode"
                    @input="handleGiftCardCodeInput($event)"
                />

                <div
                    class="purchase-rent-discount__promo-code__info"
                >
                    <h5>{{ $t('purchase-rent-page.discount.giftCard.infoLabel') }}</h5>

                    <span>
                        ${{ discountStore.giftCard ? discountStore.giftCard.amount : 0 }}
                    </span>
                </div>
            </div>
            <div class="purchase-rent-discount__device-protection">
                <switch-input
                    v-model="orderStore.insurance_status"
                    :label="$t('purchase-rent-page.discount.deviceProtection.label')"
                    :placeholder="$t('purchase-rent-page.discount.deviceProtection.insuranceLabel')"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .purchase-rent-discount {
        &__title {
            margin-bottom: 2rem;

            h1 {
                text-align: left;
                font-size: 24px;
                font-weight: 400;
                margin-bottom: .5rem;
            }
        }

        &__body {
            border-radius: 8px;
            border: 2px solid #7DD3FC;
            padding: 1.5rem;
            width: 100%;
            background: #ffffff;
        }

        &__promo-code {
            margin-bottom: 1.5rem;

            .text-input {
                margin-bottom: 1rem;

                input {
                    text-transform: uppercase;
                }
            }

            &__info {
                display: flex;
                align-items: center;

                h5 {
                    font-size: 1rem;
                    margin-right: .5rem;
                }

                span {
                    color: #7DD3FC;
                    font-size: 1.5rem;
                    font-weight: 500;
                }
            }
        }

        &__gift-code {
            margin-bottom: 1.5rem;

            .text-input {
                margin-bottom: 1rem;

                input {
                    text-transform: uppercase;
                }
            }

            &__info {
                display: flex;
                align-items: center;

                h5 {
                    font-size: 1rem;
                    margin-right: .5rem;
                }

                span {
                    color: #7DD3FC;
                    font-size: 1.5rem;
                    font-weight: 500;
                }
            }
        }
    }
</style>